import { Input, Textarea } from "common/ui-kit";
import { Formik } from "formik";
// import { toast } from "react-toastify";
import React, { useState } from "react";
import s from "./WorkWithUs.module.scss";

const WorkWithUs = () => {
  const [submitStatus, setSubmitStatus] = useState(null);
  const accessKey = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;

  if (!accessKey) {
    console.error('REACT_APP_WEB3FORMS_ACCESS_KEY is not defined. Please check your .env file and restart the dev server.');
  }

  return (
    <div className={s.workWithUs}>
      <h3>Want to work with us?</h3>
      <Formik
        validateOnMount
        enableReinitialize
        initialValues={{ fullName: "", email: "", phone: "", message: "" }}
        validate={(values) => {
          const errors = {};
          if (!values.email) {
            errors.email = "This field is required";
          } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
          ) {
            errors.email = "Invalid email address";
          }

          if (!values.fullName) {
            errors.fullName = "This field is required";
          }

          if (!values.phone) {
            errors.phone = "This field is required";
          }

          return errors;
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          const accessKey = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;
          
          if (!accessKey) {
            // toast.error("Configuration error: Access key is missing. Please check your environment variables.");
            setSubmitStatus("error");
            setSubmitting(false);
            return;
          }

          setSubmitStatus(null);

          fetch("https://api.web3forms.com/submit", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              access_key: accessKey,
              ...values,
            }),
          })
            .then(function (response) {
              if (response.ok) {
                console.log("Form submitted successfully");
                // toast.success("Success sent!");
                setSubmitStatus("success");
                resetForm();
              } else {
                console.error("Form submission failed", response.status);
                // toast.error("Failed to send form");
                setSubmitStatus("error");
              }
              setSubmitting(false);
            })
            .catch(function (error) {
              console.error("Form submission error:", error);
              // toast.error("Error sending form");
              setSubmitStatus("error");
              setSubmitting(false);
            });
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldTouched,
          setFieldValue,
          handleSubmit,
          isSubmitting,
          /* and other goodies */
        }) => {
          return (
            <>
              {submitStatus === "error" && (
                <div className={s.alert + " " + s.alert_danger}>An unexpected error occurred.</div>
              )}
              {submitStatus === "success" && (
                <div className={s.alert + " " + s.alert_success}>Form submitted successfully!</div>
              )}
              <form id="feedback" onSubmit={handleSubmit}>

                <div className={s.col}>
                  <div className={s.field}>
                    <Input
                      className={s.input}
                      value={values.fullName}
                      name="fullName"
                      type="text"
                      placeholder="Full name"
                      error={
                        errors.fullName && touched.fullName && errors.fullName
                      }
                      setFieldTouched={setFieldTouched}
                      setFieldValue={setFieldValue}
                      required
                    />
                  </div>
                  <div className={s.field}>
                    <Input
                      className={s.input}
                      value={values.email}
                      name="email"
                      type="email"
                      placeholder="E-mail"
                      error={errors.email && touched.email && errors.email}
                      setFieldTouched={setFieldTouched}
                      setFieldValue={setFieldValue}
                      required
                    />
                  </div>
                  <div className={s.field}>
                    <Input
                      className={s.input}
                      value={values.phone}
                      name="phone"
                      type="tel"
                      placeholder="Phone"
                      error={errors.phone && touched.phone && errors.phone}
                      setFieldTouched={setFieldTouched}
                      setFieldValue={setFieldValue}
                      required
                    />
                  </div>
                </div>
                <div className={s.col}>
                  <div className={s.field}>
                    <Textarea
                      className={s.input}
                      value={values.message}
                      name="message"
                      id=""
                      cols="30"
                      rows="10"
                      placeholder="Other"
                      error={touched.message && errors.message}
                      setFieldTouched={setFieldTouched}
                      setFieldValue={setFieldValue}
                      onBlur={handleBlur}
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    className={s.field}
                    // disabled={!!Object.keys(errors).length || isSubmitting}
                    // disabled
                  >
                    {isSubmitting ? "Submitting" : "Cooperate"}
                  </button>
                </div>
              </form>
            </>
          );
        }}
      </Formik>
    </div>
  );
};

export default WorkWithUs;
